import React, { useState, useEffect, useRef } from 'react';
import Card from '../../components/common/Card';
import Button from '../../components/common/Button';
import logService from '../../services/logService';

const EmailLogsView = () => {
  const [logs, setLogs] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const logContainerRef = useRef(null);

  const fetchLogs = async () => {
    setIsLoading(true);
    setError(null);
    const result = await logService.getAppLogs();
    if (result.success) {
      setLogs(result.data);
    } else {
      setError(result.error);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    fetchLogs();
  }, []);

  const scrollToTop = () => {
    if (logContainerRef.current) {
      logContainerRef.current.scrollTop = 0;
    }
  };

  const scrollToBottom = () => {
    if (logContainerRef.current) {
      logContainerRef.current.scrollTop = logContainerRef.current.scrollHeight;
    }
  };

  const containerStyle = {
    height: 'calc(100vh - 250px)',
    overflowY: 'auto',
    background: '#1e1e1e',
    color: '#d4d4d4',
    padding: '16px',
    borderRadius: '8px',
    fontFamily: 'Consolas, "Courier New", monospace',
    fontSize: '13px',
    lineHeight: '1.5',
    whiteSpace: 'pre-wrap',
    position: 'relative'
  };

  const controlsStyle = {
    display: 'flex',
    gap: '12px',
    marginBottom: '16px',
    alignItems: 'center'
  };

  const widgetStyle = {
    position: 'absolute',
    right: '24px',
    bottom: '24px',
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    zIndex: 10
  };

  const refreshButtonStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '8px'
  };

  return (
    <div style={{ position: 'relative' }}>
      <div style={controlsStyle}>
        <Button variant="secondary" onClick={fetchLogs} disabled={isLoading} style={refreshButtonStyle}>
          {isLoading ? 'Refreshing...' : 'Refresh Logs'}
        </Button>
        <span style={{ fontSize: '13px', color: 'var(--text-secondary)' }}>
          Showing last 1000 lines of email logs. Newest at the bottom.
        </span>
      </div>

      <Card padding="0">
        <div ref={logContainerRef} style={containerStyle}>
          {isLoading && !logs ? (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
              Loading logs...
            </div>
          ) : error ? (
            <div style={{ color: 'var(--error)', padding: '20px' }}>
              Error: {error}
            </div>
          ) : (
            <code>{logs || 'No logs found.'}</code>
          )}
        </div>
        
        <div style={widgetStyle}>
          <Button 
            variant="secondary" 
            onClick={scrollToTop}
            title="Scroll to Top"
            style={{ borderRadius: '50%', width: '40px', height: '40px', padding: '0', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 4px 12px rgba(0,0,0,0.3)' }}
          >
            ↑
          </Button>
          <Button 
            variant="secondary" 
            onClick={scrollToBottom}
            title="Scroll to Bottom"
            style={{ borderRadius: '50%', width: '40px', height: '40px', padding: '0', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 4px 12px rgba(0,0,0,0.3)' }}
          >
            ↓
          </Button>
        </div>
      </Card>
    </div>
  );
};

export default EmailLogsView;
